import { fork } from 'redux-saga/effects';
import loginWatchers from './loginSaga';
import verificationWatchers from './verificationSaga';
import passwordRecoveryWatchers from './passwordRecoverySaga';
import createPasswordWatchers from './createNewPasswordSaga';
import registrationWatchers from './registrationSaga';
import redirectionWatchers from './redirectionSaga';
import { initSupportInfo } from './supportInfoSaga';

/**
 * Uses fork to start multiple watchers in parallel
 * @return {void}
 */
export default function *root() {

  /* Please avoid putting blocking effects in root sagas.
  that can prevents following effects get registered on time
  and cause bugs.
  According to https://redux-saga.js.org/docs/api/,
  fork will perform a *non-blocking* call and
  call will perform a *blocking* call */
  yield fork(initSupportInfo);

  yield fork(loginWatchers);
  yield fork(redirectionWatchers);
  yield fork(verificationWatchers);
  yield fork(passwordRecoveryWatchers);
  yield fork(createPasswordWatchers);
  yield fork(registrationWatchers);
}
